import React, { useRef, useEffect } from 'react';
import IntlTelInput from "intl-tel-input/react";
import "intl-tel-input/styles";
import { PhoneNumberInputContainer } from './style';

const PhoneNumberInput = ({
  width,
  title,
  mainPage,
  required,
  additionalstyle,
  marginBottom,
  disabled,
  placeholder,
  onBlur,
  value,
  onChangeNumber,
  onPhoneValidityChange,
  error,
  errorMessage
}) => {

  const itiRef = useRef(null);
  const debounceRef = useRef(null);

  // Force data sync (External -> Internal)
  useEffect(() => {
    if (itiRef.current && value !== undefined) {
      const instance = itiRef.current.getInstance();
      const currentInternal = instance.getNumber();
      
      // ONLY sync if the value is actually different AND the user isn't typing
      if (currentInternal !== value && document.activeElement !== instance.telInput) {
        instance.setNumber(value);
      }
    }

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [value]);

  const handlePhoneChange = (number) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    
    debounceRef.current = setTimeout(() => {
      // Check if value actually changed before updating state
      if (number !== value) {
        onChangeNumber(number);
      }
    }, 10);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!itiRef.current) return;

      const instance = itiRef.current.getInstance();

      if (!instance) return;

      const container = instance.telInput?.closest('.iti');

      if (
        container &&
        !container.contains(e.target) &&
        typeof instance._closeDropdown === 'function'
      ) {
        instance._closeDropdown();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <PhoneNumberInputContainer
      mainPage={mainPage}
      additionalstyle={additionalstyle}
      error={error}
      disabled={disabled}
      width={width}
      marginBottom={marginBottom}
    >
      {title && <div className='label'>
        {title}
        {required? <span className='warning'> *</span>: null}
      </div>}
      <IntlTelInput
        ref={itiRef}
        value={value}
        initOptions={{ 
          initialCountry: 'ca',
          formatOnDisplay: true,
          nationalMode: true,
          autoPlaceholder: 'off',
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.0.10/build/js/utils.js"
        }}
        inputProps={{
          disabled: disabled,
          placeholder: placeholder,
          onBlur: onBlur,
        }}
        onChangeNumber={handlePhoneChange}
        onChangeValidity={onPhoneValidityChange}
      />
      {error? <div className="warning">{errorMessage? errorMessage:'Please enter a valid phone number'}</div>: null}
    </PhoneNumberInputContainer>
  )
}

export default PhoneNumberInput;
